import { useCallback, useEffect, useRef, useState } from 'react';

type ComputedElementHeight = number;
type WindowResizeReturnType = {
  height: ComputedElementHeight;
  reCompute: () => void;
};

export const useWindowResize = (
  cb: (winHeight: number) => ComputedElementHeight,
  reComputeOn: Array<any> = [],
): WindowResizeReturnType => {
  const propCbRef = useRef(cb);
  const [height, setHeight] = useState(window.innerHeight);
  const reCompute = useCallback(() => {
    requestAnimationFrame(() => {
      setHeight(propCbRef.current(window.innerHeight));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...reComputeOn]);

  useEffect(() => {
    reCompute();

    window.addEventListener('resize', reCompute);

    return () => window.removeEventListener('resize', reCompute);
  }, [reCompute]);

  return { height, reCompute };
};
